import { render, staticRenderFns } from "./detailPackage.vue?vue&type=template&id=3604bc8b&scoped=true&"
import script from "./detailPackage.vue?vue&type=script&lang=js&"
export * from "./detailPackage.vue?vue&type=script&lang=js&"
import style0 from "./detailPackage.vue?vue&type=style&index=0&id=3604bc8b&scoped=true&lang=css&"
import style1 from "./detailPackage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604bc8b",
  null
  
)

export default component.exports